import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout on 401
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Get All Diagnosis --------------------
function getAllDiagnosis(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/master/patientdiagnosis`;
  return apiFetch(url, requestOptions);
}

// -------------------- Add Diagnosis Master --------------------
function addDiagnosisMaster(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/master/diagnosisMaster`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Diagnosis Master --------------------
function getDiagnosisMaster() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };
  const url = `${basePath}/master/diagnosisMaster`;
  return apiFetch(url, requestOptions);
}

// -------------------- Add Diagnosis --------------------
function addDiagnosis(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/master/diagnosis`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const diagnosisServices = {
  handleResponse,
  logout,
  getAllDiagnosis,
  addDiagnosisMaster,
  getDiagnosisMaster,
  addDiagnosis,
};

export default diagnosisServices;
